__turbopack_context__.v({
  "root": "styles-module-scss-module__4o0EmW__root",
});
